<template>
  <section class="user-template-container">
    <header>
      <inline-svg
        src="/images/icons/chevron-left-solid.svg"
        class="divider"
      ></inline-svg>
      <span class="back-btn pointer" @click="$emit('show-products')">
        Terug
      </span>
      <span>
        {{ product.title }}
      </span>
    </header>
    <product-specs-header
      :product="product"
      :selected-files="selectedFiles"
      :standalone="standalone"
      @add-to-cart="$emit('add-to-cart')"
    ></product-specs-header>
    <section class="spec-container">
      <ul class="template-spec">
        <li class="product-title" v-if="productTitle">
          <h2>Product</h2>
          <div>{{ productTitle }}</div>
        </li>
        <template v-for="(value, key) in specs" :key="key">
          <li v-if="!isEmptyValue(value)">
            <h2>{{ getSpecLabel(key) }}</h2>
            <div>
              <template v-if="Array.isArray(value)">
                <span v-for="(item, index) in value" :key="index">
                  {{ item }}<br v-if="index < value.length - 1" />
                </span>
              </template>
              <template v-else>
                {{ value }}
              </template>
              <!--               <spec-button :title="value" :selected="true"> </spec-button> -->
            </div>
          </li>
        </template>
      </ul>
    </section>
  </section>
</template>

<script>
import SpecButton from '@/components/ui/SpecButton'
import ProductSpecsHeader from './productSpecs/ProductSpecsHeader.vue'

export default {
  data() {
    return {
      productTitle: ''
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    selectedFiles: {
      type: Array,
      required: true
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SpecButton,
    ProductSpecsHeader
  },
  emits: ['add-to-cart', 'show-products'],
  methods: {
    getSpecLabel(key) {
      const labelMapping = {
        title: 'Product',
        format: 'Formaat',
        colorMode: 'Kleur',
        material: 'Materiaal',
        side: 'Printzijde',
        treatment: 'Afwerking'
      }

      return labelMapping[key] || key
    },
    isEmptyValue(value) {
      // Check if value is an empty array
      if (Array.isArray(value) && value.length === 0) {
        return true
      }
      if (
        Array.isArray(value) &&
        value.length === 1 &&
        (value[0] === '' || value[0] == null)
      ) {
        return true
      }

      // Check if value is empty string or null/undefined
      if (value === '' || value == null) {
        return true
      }
      return false
    }
  },
  computed: {
    specs() {
      const specs = {}

      if (!this.product.specs) {
        for (const key in this.product) {
          if (key === 'title') {
            this.productTitle = this.product[key]
            continue
          }

          specs[key] = this.product[key]
        }
        return specs || {}
      }

      for (const key in this.product.specs) {
        /* if (this.isEmptyValue(this.product.specs[key])) {
          delete this.product.specs[key]
        } */
        if (key === 'title') {
          this.productTitle = this.product.specs[key]
          continue
        }

        specs[key] = this.product.specs[key]
      }
      return specs || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.user-template-container {
  padding: 25px 25px 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: inherit;
}

header {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  height: 19px;

  span {
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--text-color);
    margin-bottom: 0px;
    display: inline-block;
  }
}

.divider {
  height: 10px;
  margin: 0 1px 0 6px;

  :deep(g) {
    fill: var(--arch-color);
  }
}

.spec-container {
  box-shadow: var(--default-shadow);
  border-radius: 25px;
  padding: 20px;
}

.back-btn {
  color: var(--arch-color);
  font-weight: 600;
  margin-right: 13px;
}

.template-spec {
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  li {
    padding-bottom: 15px;
    flex: 0 0 calc(50% - 5px);

    &.product-title {
      flex: 0 0 100%;
    }
  }

  h2 {
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--text-color);
    margin-bottom: 10px;
  }
}
</style>
